/** Translate a normalised API error ({code, message}) into a user-facing message via i18n. */
import i18n from "@/i18n";

export function errorMessage(err, fallbackKey = "common.error") {
  const code = err?.code;
  if (code && i18n.exists(`errors.${code}`)) return i18n.t(`errors.${code}`);
  if (err?.status === 401) return i18n.t("errors.unauthorized");
  if (err?.status === 403) return i18n.t("errors.forbidden");
  if (err?.status === 404) return i18n.t("errors.not_found");
  if (err?.status === 422) return i18n.t("errors.validation_failed");
  return i18n.t(fallbackKey);
}
